module.exports = __webpack_public_path__ + "img/geriatric_parameters.fcf7f789.svg";